<div class="navbar-header">
  <div style="padding-top: 5px; padding-bottom: 4px; padding-right: 20px;">
    <img src="assets/img/meuFregues.png" width="150">
  </div>
  <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse">
    <i class="fa fa-bars"></i>
  </button>
</div>
